import sanitizeHtml from "sanitize-html";

/**
 * Sanitize SVG string before injecting with dangerouslySetInnerHTML.
 * Removes script tags, event handlers, and other unsafe content.
 */
export function sanitizeSvg(svg: string): string {
	return sanitizeHtml(svg, {
		allowedTags: [
			"svg",
			"g",
			"path",
			"circle",
			"rect",
			"line",
			"polyline",
			"polygon",
			"ellipse",
			"defs",
			"clipPath",
			"mask",
			"linearGradient",
			"radialGradient",
			"stop",
			"title",
			"desc",
		],
		allowedAttributes: {
			"*": [
				"id",
				"class",
				"aria-hidden",
				"role",
				"viewBox",
				"xmlns",
				"width",
				"height",
				"x",
				"y",
				"x1",
				"x2",
				"y1",
				"y2",
				"cx",
				"cy",
				"r",
				"rx",
				"ry",
				"d",
				"points",
				"fill",
				"fill-rule",
				"clip-rule",
				"stroke",
				"stroke-width",
				"stroke-linecap",
				"stroke-linejoin",
				"stroke-miterlimit",
				"stroke-dasharray",
				"stroke-dashoffset",
				"opacity",
				"transform",
				"clip-path",
				"mask",
				"offset",
				"stop-color",
				"stop-opacity",
				"gradientUnits",
				"gradientTransform",
				"data-preserve-green",
			],
		},
		allowedSchemes: [],
		allowProtocolRelative: false,
		parser: {
			lowerCaseTags: false,
			lowerCaseAttributeNames: false,
		},
	});
}

/**
 * Only allow same-origin paths for inline SVG fetch (no external URLs).
 * Prevents XSS via malicious SVG from user-controlled or external URLs.
 */
export function isSameOriginSvgPath(src: string): boolean {
	if (typeof src !== "string" || !src) return false;
	const trimmed = src.trim();
	if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) return false;
	if (trimmed.includes("..")) return false;
	return true;
}

/**
 * Only allow /icon-library paths (used by CategoryCard, NavDropdownItem).
 */
export function isAllowedIconLibraryPath(src: string): boolean {
	if (typeof src !== "string" || !src) return false;
	const trimmed = src.trim();
	if (!trimmed.startsWith("/icon-library")) return false;
	if (trimmed.includes("..")) return false;
	return true;
}
